export default "__VITE_ASSET__Cw4F3Ot5__"